/* chart-tooltip.ts */

/* d3.js */
import { SVGSelection } from "src/shared/types/d3";

/* Interfaces */
import { ChartTooltipRef } from "src/shared/interfaces/ChartTooltip";

/**
 *
 * @param {React.RefObject<ChartTooltipRef>} tooltipRef - Reference to the tooltip component.
 * @param {} setTooltipData - Function to set the tooltip data.
 * @param {SVGSelection} svg - SVG selection.
 * @param {MouseEvent} event - Mouse event to extract clientX and clientY.
 * @param {number} margin - Margin to adjust the tooltip position.
 * @returns {void}
 */

export interface ScssProps {
  margin?: number;
}

export const createChartTooltip = (
  tooltipRef: React.RefObject<ChartTooltipRef>,
  setTooltipData: () => void,
  svg: SVGSelection,
  event?: MouseEvent,
  scssProps?: ScssProps
): void => {
  const svgRect = svg.node()?.getBoundingClientRect();
  if (!svgRect || !event) return;

  if (!tooltipRef.current) return;
  const { showTooltip } = tooltipRef.current;

  showTooltip(
    setTooltipData()!,
    event.clientX - svgRect.left,
    event.clientY - svgRect.top + scssProps?.margin!
  );
};
